








































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { domain, User, RegisterUser, VueForm, RegisterUserResult } from "@/domain";
import * as util from "@/util";
import * as uiUtil from "@/uiUtil";
import QuickSnack from "@/components/QuickSnack.vue";
import Password from "@/components/Password.vue";

@Component({
  components: { QuickSnack, Password }
})
export default class AuthRegisterForm extends Vue {
  @Prop({ default: false }) dialog!: boolean;

  // Status
  snackbar = "";
  isLoading = false;
  step = "account";

  // Register form
  clientID = "";
  clientUsername = "";
  clientPassword = "";
  registerEmail = "";
  registerPassword = "";
  registerDisplayName = "";

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  emailKeyUpTimer: any;

  registerResult: RegisterUserResult | null = null;

  emailValidation = {
    isValid: false,
    isChecking: false,
    needsToCheck: false,
    email: "",
    exists: true
  };

  emailRules = [util.rules.required(this.lang.requiredEmailAlert), util.rules.email(this.lang.validEmailAlert)];
  clientIDRules = [util.rules.required(this.lang.ruleClientId), util.rules.numeric(this.lang.ruleNumericClientId)];
  clientUsernameRules = [util.rules.required(this.lang.ruleRequireduserName)];
  clientPasswordRules = [util.rules.required(this.lang.ruleRequiredPassword)];

  created() {
    this.reset();
  }

  reset() {
    this.goToFirst();
    this.clientID = "";
    this.clientUsername = "";
    this.clientPassword = "";
    this.registerEmail = "";
    this.registerPassword = "";
    this.registerDisplayName = "";
  }

  beforeDestroy() {
    util.log("Destroy");
    if (this.emailKeyUpTimer) {
      util.log("Destroy clear");
      clearTimeout(this.emailKeyUpTimer);
    }
  }

  goToContacts() {
    this.emitFinish("destroyed");
    uiUtil.routePush(this, "/contact");
  }

  flagEmailKeyUp(event: unknown) {
    if (this.emailKeyUpTimer) {
      clearTimeout(this.emailKeyUpTimer);
    }
    util.log("Key up event", event);
    this.emailValidation.needsToCheck = true;
    this.emailKeyUpTimer = setTimeout(() => this.checkRegisterEmail(), 400);
  }

  get lang() {
    return this.$store.state.lang.data;
  }

  get emailValidationIcon() {
    if (this.emailValidation.isChecking || this.emailValidation.needsToCheck) {
      return "mdi-timer-sand";
    } else if (this.emailValidation.email === this.registerEmail && this.emailValidation.isValid) {
      return "mdi-check";
    }
    return "";
  }

  goToFirst() {
    if (this.currentUser) {
      this.goToStep("register");
    } else {
      this.goToStep("account");
    }
  }

  get currentUser(): User | null {
    return this.$store.state.currentUser;
  }

  get currentStep(): string {
    /*if (this.step === 'login') {
      return this.currentUser ? 'login_existing' : 'login_new';
    }*/
    return this.step;
  }

  get currentTitle(): string {
    switch (this.currentStep) {
      case "account":
        return this.defaultTitle;
      case "register":
        return this.defaultTitle;
      case "finished":
        return this.defaultTitle;
      default:
        return this.step;
    }
  }

  get defaultTitle() {
    if (this.currentUser) {
      return this.lang.addCommerce;
    }
    return this.lang.registerAsAdmin;
  }

  async checkRegisterEmail(): Promise<boolean> {
    util.log("Checking...");
    if (!util.isValidEmail(this.registerEmail)) {
      this.emailValidation.needsToCheck = false;
      this.emailValidation.isValid = false;
      return false;
    }
    if (this.emailValidation.isChecking) {
      this.emailValidation.needsToCheck = true;
      return false;
    }
    this.emailValidation.needsToCheck = false;
    let success = true;
    if (this.emailValidation.email !== this.registerEmail) {
      this.emailValidation.isValid = false;
      this.emailValidation.email = this.registerEmail;
      this.emailValidation.isChecking = true;
      try {
        const result = await domain.backend.checkEmail(this.registerEmail);
        this.emailValidation.exists = result.exists;
        this.emailValidation.isValid = true;
      } catch (err) {
        util.logError("Error checking Register Email", err);
        this.snackbar = this.lang.emailValidationErr;
        success = false;
      }
      this.emailValidation.isChecking = false;
      if (this.emailValidation.needsToCheck) {
        this.$nextTick(() => this.checkRegisterEmail());
      }
    }
    return success;
  }

  async cmdConfirmAccount() {
    this.isLoading = true;
    try {
      const success = await this.checkRegisterEmail();
      if (success && this.emailValidation.isValid && (this.$refs.accountForm as VueForm).validate()) {
        this.goToStep("register");
      } else {
        this.snackbar = this.lang.dataErr;
      }
    } catch (err) {
      util.logError("Error validating account", err);
      this.snackbar = uiUtil.toErrorMsg(err, this.lang.emailVAlidationErr2);
    }
    this.isLoading = false;
  }

  async cmdRegister() {
    if ((this.$refs.registerForm as VueForm).validate()) {
      const request: RegisterUser = {
        newUser: !!this.currentUser || !this.emailValidation.exists,
        email: this.registerEmail,
        password: this.registerPassword,
        displayName: this.registerDisplayName,
        companyID: Number(this.clientID),
        paytefUser: this.clientUsername,
        paytefPassword: this.clientPassword
      };
      this.isLoading = true;
      try {
        const result = await domain.backend.registerUser(request);
        this.registerResult = result;
        this.goToStep("finished");
      } catch (err) {
        util.logError("Register error", err);
        this.snackbar = uiUtil.toErrorMsg(err, this.lang.registerErr);
      }
      this.isLoading = false;
    }
  }

  emitFinish(value: unknown) {
    this.$emit("finish", value);
  }

  goToStep(name: string) {
    util.log("Step", name);
    this.step = name;
  }
}
